import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-bundle-transfer-warning-dialog',
  templateUrl: './bundle-transfer-warning-dialog.component.html',
  styleUrls: ['./bundle-transfer-warning-dialog.component.scss']
})
export class BundleTransferWarningDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<BundleTransferWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  close(): void {
    this.dialogRef.close();
  }
}
